export const numberToFixed = (num: number, precision: number) => {
  return num.toFixed(precision)
}

export const downloadFile = (url: string, fileName?: string) => {
  const link = document.createElement("a")
  link.href = url
  link.setAttribute("download", fileName || "")
  document.body.appendChild(link)
  link.click()
}
